<template>
    <div class="newsList">
        <div class="datanull" v-show="!listcontent||!listcontent.length">
            暂无相关数据！
        </div>
        <div v-for="(item,index) in listcontent" :key="index" class="boxContent" @click="enterDetails(item)">
            <div class="oneImg" v-if="item.thumb.split(',').length<3">
                <div class="newsThumbOne">
                    <img class="newsThumb" :src="item.thumb.split(',')[0]" alt="">
                    <img src="../../assets/vedioSing.png" alt="" class="vedioPlaySign" v-if="item.video">
                </div>
                <div class="newsTitle">
                    <p class="titleName">{{item.title}}</p>
                    <div class="sorceTime">
                        <span>{{item.source}}</span>
                        <span>{{item.dateline|date}}</span>
                    </div>
                </div>
            </div>
            <div v-else class="moreImg">
                <p class="titleName">{{item.title}}</p>
                <div class="newsThumbBox">
                    <div v-for="(imgper,index) in item.thumb.split(',')" :key="index">
                        <img class="newsThumb" :src="imgper" alt="" v-if="index<3">
                    </div>
                </div>
                <div class="sorceTime">
                    <span>{{item.source}}</span>
                    <span>{{item.dateline|date}}</span>
                </div>
            </div>
            <!-- {{item}} -->
        </div>
    </div>
</template>

<script>
export default {
    props:["listcontent"],
    data(){
        return{

        }
    },
    methods:{
        enterDetails(item){
            var link;
            if(item.matrix_judge==1){
                link=window.location.href.split("#/")[0]+"#/details?id="+item.medid_id+'&judge'; //链接
            }else{
                if(item.linkerapp){
                    link=item.linkerapp; //链接
                }else{
                    link=window.location.href.split("#/")[0]+"#/details?id="+item.id; //链接
                }
            }
            this.link({url: link,title:item.title});
        }
    }
}
</script>

<style  scoped>
    .datanull{
        width: 100%;
        height: 100%;
        color: #999999;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 30px;
    }
    .boxContent{
        width: calc(100% - 24px);
        padding: 12px 0px;
        margin: 0px auto;
        box-sizing: border-box;
        border-bottom: 1px solid #eeeeee;
    }
    .oneImg{
        width:100%;
        height:80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .newsThumbBox{
        width: 100%;
        height: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .newsThumbBox>div{
        width: 32%;
        height: 100%;
    }
    .newsThumbOne{
        width: 32%;
        height: 100%;
        position: relative;
    }
    .newsThumb{
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 6px;
    }
    .vedioPlaySign{
        position: absolute;
        top: 50%;
        left: 50%;
        width: 30px;
        height: 30px;
        margin-top: -15px;
        margin-left: -15px;
        object-fit: contain;
    }
    .newsTitle{
        width: 64%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
    }
    .titleName{
        width: 100%;
        /* height:37px; */
        color: #333;
        font-size: 15px;
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .sorceTime{
        width: 100%;
        display: flex;
        justify-content: space-between;
        color: #999999;
        font-size: 12px;
    }

    /* 后期多图 */
    .moreImg{
        width: 100%;
        height: 146px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-content: space-between;
    }
</style>